import { Head } from "@inertiajs/react"

import { UserForm } from "@/components/admin/user-form"
import AppLayout from "@/layouts/app-layout"
import { adminUsersPath } from "@/routes"
import type { BreadcrumbItem, RoleOption } from "@/types"

interface Props {
  user: {
    id: number
    name: string
    email: string
    role_id: number
    verified: boolean
    archived: boolean
  }
  roles: RoleOption[]
}

export default function Edit({ user, roles }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Users", href: adminUsersPath() },
    { title: user.name, href: `/admin/users/${user.id}/edit` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit ${user.name}`} />

      <div className="max-w-2xl space-y-6 p-6">
        <div>
          <h1 className="text-2xl font-semibold">{user.name}</h1>
          {user.archived && (
            <p className="text-muted-foreground text-sm">
              This account is archived — it can&apos;t sign in and holds no
              permissions.
            </p>
          )}
        </div>
        <UserForm
          action={`/admin/users/${user.id}`}
          method="patch"
          roles={roles}
          user={user}
          submitLabel="Save Changes"
        />
      </div>
    </AppLayout>
  )
}
